import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { authConfig } from "../../views/auth/Config";
import {
  AR_ACC_ERR,
  DATA_ERR,
  EMAIL_ERR,
  NAPA_CODE_ERR,
} from "../GlobalMessageConstants";
import {
  addItemToHandleName,
  addItemToHandleEmail,
} from "../../store/HandleLogin";

export const getDateFromTS = (TS) => {
  var timestamp = new Date(TS).getTime();
  var todate = new Date(timestamp).getDate();
  var tomonth = new Date(timestamp).getMonth() + 1;
  var toyear = new Date(timestamp).getFullYear();
  return tomonth + "/" + todate + "/" + toyear;
};

export const constructDCStore = (data) => {
 const value = data != null ? String(data) : "";
 const updateStr =(val)=>{
  const  v = (val ?? '').toString();
  return v
 }
  if (Number(value) >= 1 && Number(value) <= 9) {
    return "00" + updateStr(value).replace(/^0+/, "");
  } else if (Number(value) >= 10 && Number(value) <= 99) {
    return "0" +  updateStr(value).replace(/^0+/, "");
  } else if (value === "0") {
    return "00" + value;
  } else if (value === "0000") {
    return  updateStr(value).slice(0, 3);
  } else {
    return  updateStr(value).replace(/^0+/, "");
  }
};

export const onChangeFormInfo = (
  e,
  type,
  formObject,
  helperText,
  helperStoreText,
  helperEmailText,
  error,
  dcError,
  storeError
) => {
  const regex = /^[0-9\b-]+$/;
  let updatedInfo = {
    tempJobber: { formObject },
    error: error,
    helperText: helperText,
    dcError: dcError,
    helperStoreText: helperStoreText,
    storeError: storeError,
    helperEmailText: helperEmailText,
    emailError: false,
  };
  if (type === "storeName") {
    updatedInfo.error = false;
    let tempJobber = { storeName: e.target.value };
    updatedInfo.tempJobber = tempJobber;
    return updatedInfo;
  }
  if (type === "fleetName") {
    updatedInfo.error = false;
    let tempJobber = { fleetName: e.target.value };
    updatedInfo.tempJobber = tempJobber;
    return updatedInfo;
  } else if (type === "arNo") {
    if (e.target.value && e.target.value.length !== 10) {
      updatedInfo.helperText = AR_ACC_ERR;
    } else {
      updatedInfo.helperText = "";
    }
    if (e.target.value === "" || regex.test(e.target.value)) {
      let tempJobber = { arNo: e.target.value };
      updatedInfo.tempJobber = tempJobber;
    }
    return updatedInfo;
  } else if (type === "phone") {
    if (e.target.value === "" || regex.test(e.target.value)) {
      let tempJobber = { phone: e.target.value };
      updatedInfo.tempJobber = tempJobber;
    }
    return updatedInfo;
  } else if (type === "napaStoreCode") {
    if (e.target.value !== "") {
      if (constructDCStore(e.target.value).length > 3) {
        updatedInfo.helperStoreText = NAPA_CODE_ERR;
      } else {
        updatedInfo.helperStoreText = "";
        updatedInfo.storeError = false;
      }
      let tempJobber = { napaStoreCode: constructDCStore(e.target.value) };
      updatedInfo.tempJobber = tempJobber;
    }
    return updatedInfo;
  } else if (type === "email") {
    if (e.target.value && !e.target.value.match(/\S+@\S+\.\S+/)) {
      updatedInfo.helperEmailText = EMAIL_ERR;
    } else {
      updatedInfo.helperEmailText = "";
      updatedInfo.emailError = false;
    }
    let tempJobber = { email: e.target.value };
    updatedInfo.tempJobber = tempJobber;
    return updatedInfo;
  } else {
    let key = type;
    let tempJobber = { [key]: e.target.value };
    updatedInfo.tempJobber = tempJobber;
    return updatedInfo;
  }
};

export const validateStoreForm = (
  error,
  emailError,
  storeError,
  dcError,
  valid,
  storeName,
  helperEmailText,
  napaStoreCode,
  dcCode,
  errorList
) => {
  let updatedFormValidation = {
    error: error,
    valid: valid,
    emailError: emailError,
    storeError: storeError,
    dcError: dcError,
    errorList: errorList,
  };
 let dc_err, napa_err
  if (errorList?.validationError || !dcCode ||dcCode?.length === 0||Object.keys(dcCode)?.length===0) {
    updatedFormValidation.dcError = true;
    updatedFormValidation.valid = false;

    dc_err = {
      
       dcCodeError: { ...updatedFormValidation?.errorList?.dcCodeError, dataErr: true, message:DATA_ERR },
    };

  }
  if (!storeName || storeName.length === 0) {
    updatedFormValidation.error = true;
    updatedFormValidation.valid = false;
  }
  if (helperEmailText && helperEmailText.length > 0) {
    updatedFormValidation.emailError = true;
    updatedFormValidation.valid = false;
  }
  if (!napaStoreCode && napaStoreCode.length !== 3) {
    updatedFormValidation.storeError = true;
    updatedFormValidation.valid = false;
     updatedFormValidation.napaCodeError = true;
    updatedFormValidation.valid = false;
    napa_err = {
      ...updatedFormValidation.errorList,
      napaCodeError: { ...updatedFormValidation?.errorList?.napaCodeError, dataErr: true, message:DATA_ERR },
    };
  }

  updatedFormValidation.errorList={...napa_err, ...dc_err}
 
  return updatedFormValidation;
};

export const getStatesByCountry = (countries, country) => {
  let tempStatesByCounty = { selectedCountry: {}, tempStates: [] };
  for (let i = 0; i < countries.length; i++) {
    if (countries[i].name === country) {
      tempStatesByCounty.selectedCountry = {
        id: countries[i].id,
        name: country,
      };
      tempStatesByCounty.tempStates = countries[i].states;
      return tempStatesByCounty;
    }
  }
};

export const getSelectedState = (states, state) => {
  let selectedState = {};
  for (let i = 0; i < states.length; i++) {
    if (states[i].name === state) {
      selectedState = {
        id: states[i].id,
        name: state,
      };
      return selectedState;
    }
  }
};

export const getMessages = (
  jobber,
  helperText,
  helperStoreText,
  helperEmailText,
  successMsg
) => {
  let MessageList = [];
  if (jobber && jobber.storeName && helperText) {
    MessageList.push({ helperText: helperText, type: "error" });
  }
  if (jobber && jobber.fleetName && helperText) {
    MessageList.push({ helperText: helperText, type: "error" });
  }

  if (jobber && jobber.storeName && helperStoreText) {
    MessageList.push({ helperText: helperStoreText, type: "error" });
  }

  if (jobber && jobber.storeName && helperEmailText) {
    MessageList.push({ helperText: helperEmailText, type: "error" });
  }
  if (jobber && jobber.fleetName && helperEmailText) {
    MessageList.push({ helperText: helperEmailText, type: "error" });
  }

  if (jobber && jobber.storeName && successMsg) {
    MessageList.push({ helperText: successMsg, type: "success" });
  }
  if (jobber && jobber.fleetName && successMsg) {
    MessageList.push({ helperText: successMsg, type: "success" });
  }
  return MessageList;
};
export const generateRandomValue = () => {
  let crypto = window.crypto || window.msCrypto;
  let D = new Uint32Array(2);
  crypto.getRandomValues(D);
  return D[0].toString(36);
};

export const generateStateNonceAndHitURL = () => {
  const state = generateRandomValue();
  const nonce = generateRandomValue();
  sessionStorage.setItem("state", state);
  sessionStorage.setItem("nonce", nonce);
  let authUrl =
    `${authConfig.ssoUrl}` +
    `/${authConfig.tenantId}/authorize?` +
    `client_id=${authConfig.clientId}&` +
    `response_type=${authConfig.responseType}&` +
    `redirect_uri=${authConfig.redirectUri}&` +
    `response_mode=${authConfig.responseMode}` +
    (authConfig.scope
      ? `&scope=${authConfig.scope + authConfig.clientId}/user.read`
      : "") +
    (state ? `&state=${state}` : "") +
    (nonce ? `&nonce=${nonce}` : "");
  window.location.replace(authUrl);
};

export const decodeTokenAndCheckExpiry = (accessToken, idToken, dispatch) => {
  const decodeAccess = jwtDecode(accessToken);
  const decodeId = jwtDecode(idToken);
  const expireTime = decodeAccess.exp;
  const expireTimeId = decodeId.exp;
  const currentTime = new Date().getTime() / 1000;
  if (currentTime < expireTime && currentTime < expireTimeId) {
    dispatch(addItemToHandleName(decodeAccess.name));
    dispatch(addItemToHandleEmail(decodeAccess.email));
  } else {
    document.cookie = "";
    Cookies.remove("access_token");
    Cookies.remove("id_token");
    window.location.replace("/fleet-survey/");
  }
};

export const fetchAndValidateToken = (dispatch) => {
  const accessToken = Cookies.get("access_token");
  const idToken = Cookies.get("id_token");
  if (
    (accessToken === "" || accessToken === undefined) &&
    (idToken === "" || idToken === undefined)
  ) {
    generateStateNonceAndHitURL();
  } else {
    decodeTokenAndCheckExpiry(accessToken, idToken, dispatch);
  }
};

export const getDateString = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}${month}${day}`;
};
